import React, { useState } from 'react';
import { GenerateImageContext } from './generate-image-context';

export const GenerateImageContextProvider = (props) => {
  const [generateImageExample, setGenerateImageExample] = useState({
    prompt: undefined,
    imageUrl: undefined,
  });

  return (
    <GenerateImageContext.Provider
      value={{
        generateImageExample,
        setGenerateImageExample,
      }}
    >
      {props.children}
    </GenerateImageContext.Provider>
  );
};

export const withGenerateImageContext = Component => props => (
  <GenerateImageContextProvider>
    <Component {...props} />
  </GenerateImageContextProvider>
);
